import React from 'react';
import styled from 'styled-components';
import WaveDivider from './WaveDivider.jsx';

// Styled Components
const SkillsSection = styled.section`
  background: #f8fafc;
  padding: 0 0 100px 0;
  margin: 0 0 0 0;
  position: relative;
  overflow: hidden;
  isolation: isolate;
`;

const SectionTitle = styled.h2`
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 3rem;
  color: #333;
  position: relative;
  font-family: var(--font-heading);
  font-weight: 700;

  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 4px;
    background: linear-gradient(90deg, #667eea, #764ba2);
    border-radius: 2px;
  }
`;

const SkillsContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
`;

const SkillsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-bottom: 3rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

const SkillCategory = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07);
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  }
`;

const CategoryTitle = styled.h3`
  font-family: var(--font-heading);
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  i {
    color: #667eea;
    font-size: 1.2rem;
  }
`;

const SkillsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

const SkillTag = styled.span`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 0.4rem 0.8rem;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(102, 126, 234, 0.3);
  }
`;

const Skills = () => {
  const skillsData = [
    {
      category: "Frontend",
      icon: "fas fa-code",
      skills: ["React", "JavaScript", "HTML5", "CSS3", "Responsive Design", "UI/UX"]
    },
    {
      category: "Backend",
      icon: "fas fa-server",
      skills: ["Node.js", "Express", "REST APIs", "Microservices", "Database Design"]
    },
    {
      category: "DevOps",
      icon: "fas fa-cogs",
      skills: ["Docker", "CI/CD", "Git", "Cloud Deployment", "Monitoring"]
    },
    {
      category: "Tools",
      icon: "fas fa-tools",
      skills: ["VS Code", "Git", "Terminal", "Postman", "Figma"]
    }
  ];

  return (
    <SkillsSection id="skills">
      <SectionTitle>Fähigkeiten</SectionTitle>
      <SkillsContainer>
        <SkillsGrid>
          {skillsData.map((category, index) => (
            <SkillCategory key={index}>
              <CategoryTitle>
                <i className={category.icon}></i>
                {category.category}
              </CategoryTitle>
              <SkillsList>
                {category.skills.map((skill, skillIndex) => (
                  <SkillTag key={skillIndex}>{skill}</SkillTag>
                ))}
              </SkillsList>
            </SkillCategory>
          ))}
        </SkillsGrid>
      </SkillsContainer>
      <WaveDivider 
        color="white" 
        variant="gentle" 
        animated={true}
        height={120}
      />
    </SkillsSection>
  );
};

export default Skills; 